import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  inject,
  OnInit,
  Output,
  signal,
  ViewChild,
} from '@angular/core';
import { HomeService } from '../../services/home.service';
import { ModalController, PopoverController } from '@ionic/angular';
import { AuthService } from '../../../login/services/auth.service';
import { SessionAuthService } from '../../../login/services/session-auth.service';
import { Router } from '@angular/router';
import { NoTranslateMaterialSymbolsDirective } from '../../../../shared/directives/noTranslateMaterialSymbols.directive';
import { ModalFormHomeService } from '../../components/modal-form-home/service/modal-form-home.service';
import { ModalFormService } from '../../../../shared/components/modal-form/service/modal-form.service';
import { LoadSpinnerComponent } from '../../../../shared/components/load-spinner/load-spinner.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { finalize } from 'rxjs';
import { UserContextService } from '../../../../services/user-context.service';

@Component({
  selector: 'app-footer-menu',
  imports: [
    CommonModule,
    NoTranslateMaterialSymbolsDirective,
    LoadSpinnerComponent,
    NgxSkeletonLoaderModule,
  ],
  templateUrl: './footer-menu.component.html',
  styleUrl: './footer-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterMenuComponent implements OnInit {
  @Output() clickedLeaf: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('userMenuTrigger', { static: false }) userMenuTrigger!: ElementRef;

  private readonly userContext = inject(UserContextService);
  private readonly sessionAuth = inject(SessionAuthService);
  private readonly homeService = inject(HomeService);
  private readonly popoverController = inject(PopoverController);
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  readonly modalController = inject(ModalController);
  readonly modalFormHomeService = inject(ModalFormHomeService);
  readonly modalFormService = inject(ModalFormService);

  num_socio: any;
  rol: any;
  notificaciones: any = [];
  cantidadNotificacionesNoVistas: number = 0;
  appTruncateText = true;

  readonly companyId = this.userContext.companyId;
  readonly companyName = this.userContext.companyName;
  readonly userName = this.userContext.userName;
  readonly userRole = this.userContext.userRoleLabel;
  readonly isProd = this.userContext.isProd;
  readonly isLoadingUserData = this.userContext.isLoading;

  isLoadingLogout = signal(false);
  isUserMenuOpen = signal(false);
  readonly canSwitchUser = this.sessionAuth.canImpersonateVisible;
  readonly isImpersonating = signal(false);

  get isExpanded(): boolean {
    return this.homeService.isExpanded;
  }

  ngOnInit(): void {
    this.isImpersonating.set(this.sessionAuth.isImpersonating());
  }

  switchUser(): void {
    this.isUserMenuOpen.set(false);
    this.userContext.clear();
    this.sessionAuth.switchUser();
    this.userContext.initialize();
  }

  getNotifications(event): void {
    /*this.homeService.getNotifications(this.num_socio).subscribe(
      (result: any) => {
        this.notificaciones = result;
        if (event != null) {
          this.mostrarNotificaciones(event);
        }
      },
      error => {},
      () => {
        this.cantidadNotificacionesNoVistas = this.notificaciones.filter(
          notif => notif.web_status == 'new'
        ).length;
      }
    );*/
  }
  changeState(notification_id, web_status): void {
    this.homeService.changeNotificationStatus(
      notification_id,
      web_status,
      this.num_socio
    );
  }

  obtenerIDs(arregloObjetos: any[]): number[] {
    const filteredObjects = arregloObjetos.filter(
      objeto => objeto.web_status === 'new'
    );
    return arregloObjetos.map(objeto => objeto.id);
  }

  async logout() {
    if (this.isLoadingLogout()) return; // evitar dobles clics
    this.isLoadingLogout.set(true);
    this.isUserMenuOpen.set(false); // Cerrar el submenú al hacer logout
    // await this.loading.iniciar('Cerrando sesión');
    this.authService
      .logout()
      .pipe(
        finalize(() => {
          // asegurar que el spinner se detiene siempre
          this.isLoadingLogout.set(false);
        })
      )
      .subscribe({
        next: async () => {
          this.router.navigate(['/login']);
        },
        error: () => {
          // En caso de error, nos aseguramos de acabar en login igualmente
          this.router.navigate(['/login']);
        },
      });
  }

  // async onModalDataProtection() {
  //   const modal = await this.modalController.create({
  //     component: ModalEmailSoporteComponent,
  //     cssClass: 'panel-cuaderno-formato-modal',
  //     componentProps: {},
  //     showBackdrop: false,
  //     id: 'data-protection',
  //   });
  //   await modal.present();
  // }
  async mensajeASoporteModal() {
    this.modalFormHomeService.setSupportPrefill(null);
    this.modalFormHomeService.setDrawerComponent('home');
    this.homeService.modalMode.next('enviarASoporte'); // Indicamos que el modal es para soporte
    this.modalFormHomeService.openDrawerHome.next(true);
    this.modalFormHomeService.showingModalHome.next(true);
    this.homeService.errorSetState.next('');

    //Cerrar otros modal si estan abiertos
    this.modalFormService.showingModal.next(false);
    this.modalFormService.closeDrawer.next(false);

    //cerrar menu principal si esta en mobile
    this.closeMenu();
  }

  openNotificationsPanel(): void {
    this.homeService.openNotificationsPanel();
    //cerrar menu principal si esta en mobile
    this.closeMenu();
  }

  closeMenu() {
    this.clickedLeaf.emit();
  }

  toggleUserMenu() {
    this.isUserMenuOpen.set(!this.isUserMenuOpen());
    console.log('User menu toggled:', this.isUserMenuOpen()); // Debug

    if (this.isUserMenuOpen()) {
      // Calcular la posición del submenú
      setTimeout(() => {
        this.repositionSubmenu();
      }, 0);
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.user-menu')) {
      this.isUserMenuOpen.set(false);
    }
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize(_event: UIEvent) {
    if (this.isUserMenuOpen()) {
      // Reposicionar el menú cuando cambie el tamaño de la ventana
      this.repositionSubmenu();
    }
  }

  private repositionSubmenu() {
    if (this.userMenuTrigger) {
      const triggerElement = this.userMenuTrigger.nativeElement;
      const rect = triggerElement.getBoundingClientRect();
      const submenu = document.querySelector('.user-submenu') as HTMLElement;

      if (submenu) {
        const isMobile = window.innerWidth <= 1024;

        if (isMobile) {
          // En móvil, posicionar el popup dentro del viewport
          const submenuHeight = submenu.offsetHeight || 150;
          const viewportHeight = window.innerHeight;
          const viewportWidth = window.innerWidth;

          // Calcular top para que no se salga de la pantalla
          let top = rect.top - submenuHeight - 10;
          if (top < 10) {
            top = 10;
          }
          if (top + submenuHeight > viewportHeight - 10) {
            top = viewportHeight - submenuHeight - 10;
          }

          submenu.style.top = `${top}px`;
          submenu.style.left = '10px';
          submenu.style.right = '10px';
          submenu.style.width = `${viewportWidth - 20}px`;
        } else {
          submenu.style.top = `${rect.top}px`;
          submenu.style.left = `${rect.right + 10}px`;
          submenu.style.right = 'auto';
          submenu.style.width = 'auto';
        }
      }
    }
  }

  goToConfig(): void {
    this.isUserMenuOpen.set(false);
    this.router.navigate(['/configuracion']);
  }

  goToObtenerGeojson(): void {
    this.isUserMenuOpen.set(false);
    this.router.navigate(['/obtener-geojson']);
  }
}
